// @flow
import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { SPStreamingProjectContext } from '@streaming-projects/sp-page/contexts/SPStreamingProjectContext';
import { DeleteButton } from '@presentational/buttons/DeleteButton';

import { useSPTableFlowContext } from '../contexts/SPTableFlowWorkloadContextProvider';

import { SPTableFlowWorkloadDeleteWarningModal } from './SPTableFlowWorkloadDeleteWarningModal';

export const SPTableFlowWorkloadDeleteContainer = () => {
  const { tableFlowWorkloadId } = useParams();
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const spTableFlowWorkloadData = useSPTableFlowContext();
  const spStreamingProjectData = useContext(SPStreamingProjectContext);

  return (
    <>
      <DeleteButton
        onClick={() => {
          setDeleteModalOpen(true);
        }}
        size="large"
      />
      <SPTableFlowWorkloadDeleteWarningModal
        isOpen={isDeleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        spVersion={spStreamingProjectData?.sp?.version}
        tableFlowWorkloadId={tableFlowWorkloadId}
        tableFlowWorkloadName={spTableFlowWorkloadData?.name}
        tableFlowWorkloadResourceId={spTableFlowWorkloadData?.tableflow_resource_id}
      />
    </>
  );
};
